<template>
  <div
    class="grid grid-cols-8 gap-0 h-screen font-abeezee overflow-hidden color-secondary"
  >
    <div
      v-if="!showLeftSide"
      class="h-screen z-30 flex flex-col justify-center bg-gray-100 col-span-1 md:col-span-1 lg:hidden background-black items-center"
      @click="handleLeftSideShow"
    >
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="24 / arrows / chevron-right">
          <path
            id="icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.5859 12L7.29297 4.70712L8.70718 3.29291L17.4143 12L8.70718 20.7071L7.29297 19.2929L14.5859 12Z"
            class="fill-primary"
          />
        </g>
      </svg>
    </div>
    <div
      class="background-black text-left p-3 pb-0 col-span-8 sm:col-span-8 md:col-span-8 lg:col-span-2 hidden sm:hidden md:hidden lg:block"
    >
      <BasicInfo />
    </div>
    <div
      class="flex flex-column overflow-hidden background-white col-end-9 col-start-2 sm:col-start-2 md:col-start-2 lg:col-start-3"
    >
      <ScrollView class="scroll-container w-full" />
    </div>
    <transition
      enter-active-class="anim-slide-right"
      leave-active-class="anim-slide-left"
    >
      <div
        v-if="showLeftSide"
        class="fixed w-screen h-screen grid grid-cols-8 gap-0 background-black"
      >
        <BasicInfo class="p-5 col-span-7" />
        <div
          v-if="showLeftSide"
          class="h-screen z-30 flex flex-col justify-center bg-gray-100 col-span-1 md:col-span-1 lg:hidden background-white items-center"
          @click="handleLeftSideHide"
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="16 / chevron-left">
              <path
                id="icon"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17.5605 19.9394L15.4392 22.0607L5.37854 12L15.4392 1.93936L17.5605 4.06068L9.62118 12L17.5605 19.9394Z"
                class="fill-secondary"
              />
            </g>
          </svg>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ScrollView from '../components/scroll-view'
import BasicInfo from '../components/basic-info'

export default {
  name: 'Home',
  components: {
    ScrollView,
    BasicInfo,
  },
  data() {
    return {
      showLeftSide: false,
    }
  },
  computed: {
    smallScreen() {
      return window.innerWidth <= 1280
    },
  },
  methods: {
    handleLeftSideShow() {
      this.showLeftSide = true
    },
    handleLeftSideHide() {
      console.log('here')
      this.showLeftSide = false
    },
  },
}
</script>

<style lang="css">
.background-black {
  background-color: var(--secondary);
  color: var(--primary);
}
.border-color {
  color: var(--primary);
}
.border-rounded {
  border-radius: 1rem;
}
.scroll-container {
  scroll-snap-type: mandatory;
  scroll-snap-points-y: repeat(100vh);
  scroll-snap-type: y mandatory;
}
.top-50 {
  top: 50%;
}

@keyframes slide-right {
  from {
    transform: translate(-100%, 0);
    opacity: 0;
  }
  to {
    transform: translate(0, 0);
    opacity: 1;
  }
}

@keyframes slide-left {
  from {
    transform: translate(0, 0);
    opacity: 1;
  }
  to {
    transform: translate(-100%, 0);
    opacity: 0;
  }
}

.anim-slide-right {
  animation-name: slide-right;
  animation-duration: 0.5s;
}

.anim-slide-left {
  animation-name: slide-left;
  animation-duration: 0.5s;
}
</style>
